import AxiosRequest from './axios-base';
import {AxiosInstance, AxiosRequestConfig} from 'axios';
import {getHeaders} from '@/utils';

class HttpRequest {
	baseRequest: AxiosInstance;

	constructor() {
		this.baseRequest = AxiosRequest;
	}

	async getAsync(url: string, config?: AxiosRequestConfig) {
		this.baseRequest.defaults.headers = getHeaders();
		return this.baseRequest.get(url, config);
	}

	async postAsync(url: string, data?: unknown, config?: AxiosRequestConfig) {
		this.baseRequest.defaults.headers = getHeaders();
		return this.baseRequest.post(url, data, config);
	}

	async putAsync(url: string, data?: unknown, config?: AxiosRequestConfig) {
		this.baseRequest.defaults.headers = getHeaders();
		return this.baseRequest.put(url, data, config);
	}

	async deleteAsync(url: string, config?: AxiosRequestConfig) {
		this.baseRequest.defaults.headers = getHeaders();
		return this.baseRequest.delete(url, config);
	}

	get(url: string, config?: AxiosRequestConfig) {
		this.baseRequest.defaults.headers = getHeaders();
		return this.baseRequest.get(url, config);
	}

	post(url: string, data?: unknown, config?: AxiosRequestConfig) {
		this.baseRequest.defaults.headers = getHeaders();
		return this.baseRequest.post(url, data, config);
	}

	delete(url: string, config?: AxiosRequestConfig) {
		this.baseRequest.defaults.headers = getHeaders();
		return this.baseRequest.delete(url, config);
	}

	put(url: string, data?: unknown, config?: AxiosRequestConfig) {
		this.baseRequest.defaults.headers = getHeaders();
		return this.baseRequest.put(url, data, config);
	}
}

export default new HttpRequest();
